import React from "react";
import { getLocalizedString } from "@icarius-localization/strings";
import { CloseIcon } from "@icarius-icons";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@material-ui/core";
import DialogTitleDivider from "@icarius-common/dialogTitleDivider";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import PaperDraggable from "@icarius-common/paperDraggable";
import DialogTransition from "@icarius-common/dialogTransition";
import Loader from "@icarius-common/loader";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const QueryDialog = (props) => {

  const {
    open,
    isLoading,
    data,
    handleClose,
  } = props;

  return (
    <Dialog
      open={open}
      TransitionComponent={DialogTransition}
      PaperComponent={PaperDraggable}
      maxWidth={"sm"}
      fullWidth={true}
    >
      <div className={"dialog-container"}>
        <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
          {getLocalizedString("fieldNamesForQueries")}
          <DialogTitleDivider />
        </DialogTitle>
        <CloseIcon className={"dialog-close-icon icon"} onClick={handleClose} />
        <DialogContent>
          <Loader open={isLoading} />
          <Grid container direction="column" item xs={12}>
            <TextFieldMultiline
              disabled
              fullWidth
              label={getLocalizedString("sql")}
              rows={25}
              margin={"none"}
              value={data}
              inputProps={{ spellCheck: 'false' }}
            />
          </Grid>
        </DialogContent>
        <DialogActions>
          <ButtonDialogAction onClick={handleClose} isAccept text={getLocalizedString("accept")} />
        </DialogActions>
      </div>
    </Dialog >
  );
}

export default QueryDialog;